import React from 'react'
import { graphql } from 'gatsby'
import CardList from './CardList'
import Card from './Card'

const LatestNews = ({ posts }) => {

  return (
    <section className="g-py-100">
    <div className="container" data-sal="slide-up">
      <header className="text-center g-width-60x--md mx-auto g-mb-50">
        <div className="u-heading-v2-3--bottom g-brd-primary g-mb-20">
          <h2 className="h4 u-heading-v2__title g-color-gray-dark-v2 g-font-weight-600 text-uppercase">Our Latest Posts</h2>
        </div>
        <p className="g-font-size-16">Hempgrid partners with the brightest minds in the Hemp industry to bring you the news and insights you need to succeed.</p>
      </header>

      <CardList>
        {posts.map(({ node: post }) => (
          <Card key={post.id} {...post} basePath="/" />
        ))}
      </CardList>
    </div>
  </section>
  
  )
}

export default LatestNews
